import { Link } from '@sainsburys-tech/luna-link';
import * as React from 'react';
export default {
  Link,
  React
};